export default __webpack_public_path__ + "static/media/cft-project.ea0f6afd.jpg";